import React, { useCallback, useMemo, useState } from "react";
import TFGInstructorAllocationCreateDialog from "./TFGInstructorAllocationCreateDialog";

/**
 * Hook to manage the visibility and rendering of the TFGInstructorAllocationCreateDialog
 * @param {{coord: any, academicYear: string, onSave: function}} params
 */
const useTFGInstructorAllocationCreateDialog = ({ coord, academicYear, onSave }) => {
  const [visible, setVisible] = useState(false);

  const open = useCallback(() => setVisible(true), []);
  const hide = useCallback(() => setVisible(false), []);

  const DialogElement = useMemo(() => {
    if (!coord || !academicYear) return null;
    return (
      <TFGInstructorAllocationCreateDialog
        coord={coord}
        academicYear={academicYear}
        visible={visible}
        onHide={hide}
        onSave={onSave}
      />
    );
  }, [coord, academicYear, visible, hide, onSave]);

  return { open, hide, DialogElement, visible };
};

export default useTFGInstructorAllocationCreateDialog;
